export const environment = {
  production: true,
  sharePointUrl: '#{sharePointUrl}#',
  maxFileSize: 358400,
  maxOfficeShowCaseFileSize: 2000000,
  urbanPaceUrl: '#{urbanPaceUrl}#',
  assetsUrl: '#{assetsUrl}#',
  qrcodeBaseUrl: '#{qrcodeBaseUrl}#',
  base_url: '#{baseUrl}#',
  captchaKey: '#{captchaKey}#',
  fnisToolsUrl: '#{fnisToolsUrl}#',
  fnisToolsDelegateUrl: '#{fnisToolsDelegateURL}#',
  subscriptionSystemId: 1,
  fnisToolsUrlBranchAdminUrl: '#{fnisToolsUrlBranchAdminUrl}#',
  scopes: ["user.read"],
  appId: '#{appId}#',
  authority: 'https://login.microsoftonline.com/#{authority}#',
  graphEndPoint: "https://graph.microsoft.com/v1.0/me",
  microsoftApiUrl: "/",
  portalScope: ['#{portalScope}#'],
  redirectUrl: "/",
  lnfServiceDeskemail: 'ServiceDesk@longandfoster.com',   
  safariPrintAlert: 'Please use chrome browser for better experience in Print.',
  websiteAccountCustomUrlProtocol: 'http://',
  imageUrl: '#{agentPhotoURL}#',
  agentRecognitionPreviewUrl: '#{officeAgentPreviewUrl}#',
  identityServiceClientId: '#{idpClientId}#',
  identityServiceClientSecret: '#{idpClientSecret}#',
  idpFormUrl: '#{idpFormUrl}#',  
  identityServiceRedirectUrl: '#{idpFormRedirectUrl}#',
  portalLinkAppId: '#{portalLinkAppId}#',
  delegateRedirectUrl: '#{delegateUrl}#',
  delegateLogoutUrl: '#{delegateLogoutUrl}#',
  delegateSessionOverRedirectUrl: '#{delegateSessionOverRedirectUrl}#',
  delegateSessionTimeoutSecs: '#{delegateSessionTimeoutSecs}#',
  delegateSessionTimeoutAlertBefore: '#{delegateSessionTimeoutAlertBefore}#',
  enableRentalLeadSubMenu: '#{enableRentalLeadSubMenu}#',
  enableBuyerLeadSubMenu: '#{enableBuyerLeadSubMenu}#',
  buyerLeadPolicyLink :'#{buyerLeadPolicyLink}#',
  rentalLeadPolicyLink :'#{rentalLeadPolicyLink}#',
  rentalLeadPolicySupportLink :'#{rentalLeadPolicySupportLink}#',
  enableCoopCompSubMenu: '#{enableCoopCompSubMenu}#',
  coopCompRemarksRegex : '#{coopCompRemarksRegex}#',
  agreementImageUrl: '#{agreementImageUrl}#'
};
